/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeFieldSetGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Field Set Group Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, March 06, 2019 - 12:46 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      03/06/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const FIELDSETGROUP_LIST_CONTAINER_LOADED = 'FIELDSETGROUP_LIST_CONTAINER_LOADED';
export const FIELDSETGROUP_LIST_CONTAINER_UNLOADED = 'FIELDSETGROUP_LIST_CONTAINER_UNLOADED';
export const FIELDSETGROUP_LIST_TABLE_LOADED = 'FIELDSETGROUP_LIST_TABLE_LOADED';
export const FIELDSETGROUP_LIST_TABLE_UNLOADED = 'FIELDSETGROUP_LIST_TABLE_UNLOADED';

export const FIELDSETGROUP_SELECT_ROW = 'FIELDSETGROUP_SELECT_ROW';

export const FIELDSETGROUP_ADD = 'FIELDSETGROUP_ADD';
export const FIELDSETGROUP_EDIT = 'FIELDSETGROUP_EDIT';
export const FIELDSETGROUP_DELETE = 'FIELDSETGROUP_DELETE';
export const FIELDSETGROUP_OPEN_WARNING = 'FIELDSETGROUP_OPEN_WARNING';
export const FIELDSETGROUP_CLOSE_WARNING = 'FIELDSETGROUP_CLOSE_WARNING';
export const FIELDSETGROUP_DELETE_DISABLE = 'FIELDSETGROUP_DELETE_DISABLE';
export const FIELDSETGROUP_VIEW_CHILD_ITEMS = 'FIELDSETGROUP_VIEW_CHILD_ITEMS';

export const FIELDSETGROUP_EDIT_CONTAINER_LOADED = 'FIELDSETGROUP_EDIT_CONTAINER_LOADED';
export const FIELDSETGROUP_EDIT_CONTAINER_UNLOADED = 'FIELDSETGROUP_EDIT_CONTAINER_UNLOADED';
export const FIELDSETGROUP_EDIT_FORM_LOADED = 'FIELDSETGROUP_EDIT_FORM_LOADED';
export const FIELDSETGROUP_EDIT_FORM_UNLOADED = 'FIELDSETGROUP_EDIT_FORM_UNLOADED';

export const FIELDSETGROUP_EDIT_DATA_LOAD = 'FIELDSETGROUP_EDIT_DATA_LOAD';

export const FIELDSETGROUP_EDIT_CONTAINER_SUBMIT = 'FIELDSETGROUP_EDIT_CONTAINER_SUBMIT';
export const FIELDSETGROUP_EDIT_CONTAINER_CANCEL = 'FIELDSETGROUP_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeFieldSetGroups.js